export function getLogo(value) {
  if (!value) return;
  return `<img data-src="/incl/images/${value}" class="lazyload" />`;
}
